
import { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MyContext } from '../../Context/MyProvider';

const Footer = () => {

    const { BaseUrl, webLogo, instagramUrl, twitterUrl, linkedinUrl, facebookUrl, youtubeUrl, dynamicPages } = useContext(MyContext);

    const location = useLocation();
    const GetDate = new Date();

    const scrollToSection = (id) => {
        if (location.pathname !== "/") {
            window.location.href = `/#${id}`;
        } else {
            document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
        }
    }

    const isValidSocialLink = (url) => {
        return url && url.trim() !== "" && url.trim() !== "#";
    };

    const formatExternalLink = (url) => {
        if (!url) return "#";
        const trimmed = url.trim();
        if (trimmed.startsWith("http://") || trimmed.startsWith("https://") || trimmed.startsWith("//")) {
            return trimmed;
        }
        return `https://${trimmed}`;
    };

    const socialsList = [
        {
            title: "Instagram", href: instagramUrl, icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="2" y="2" width="20" height="20" rx="4" stroke="white" strokeWidth="1.5" />
                <circle cx="18" cy="6" r="1" fill="white" />
                <circle cx="12" cy="12" r="5" stroke="white" strokeWidth="1.5" />
            </svg>
        },
        {
            title: "X", href: twitterUrl, icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" fill="white" />
            </svg>
        },
        {
            title: "LinkedIn", href: linkedinUrl, icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="4" cy="4" r="2" stroke="white" strokeWidth="1.5" />
                <path d="M2 8.5H6V22H2V8.5Z" stroke="white" strokeWidth="1.5" strokeLinejoin="round" />
                <path d="M9 22H13V15C13 13.8954 13.8954 13 15 13C16.1046 13 17 13.8954 17 15V22H21V15C21 11.6863 18.3137 9 15 9C14.2987 9 13.6256 9.12031 13 9.34141V8.5H9V22ZM9 22V15" stroke="white" strokeWidth="1.5" strokeLinejoin="round" />
            </svg>
        },
        {
            title: "Facebook", href: facebookUrl, icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 2H15C12.2386 2 10 4.23858 10 7V10H7V14H10V22H14V14H17L18 10H14V7C14 6.44772 14.4477 6 15 6H18V2Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        },
        {
            title: "YouTube", href: youtubeUrl, icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="2" y="4" width="20" height="16" rx="4" stroke="white" strokeWidth="1.5" />
                <path d="M10 9L15 12L10 15V9Z" fill="white" />
            </svg>
        }
    ].filter(item => isValidSocialLink(item.href));

    return (
        <div className='footer_page'>
            <div className="width_container">

                <div className="flex max-_770_:flex-wrap items-start justify-between pb-[40px] max-_770_:gap-6">

                    <div className="w-[40%] max-_770_:w-full text-white">
                        <Link to="/" className="text-2xl max-_426_:text-[20px] font-bold text-white tracking-tight flex items-center gap-2">
                            <img src={BaseUrl + webLogo} className='w-[30px]' alt="web logo" />
                            AstroSphere API
                        </Link>
                        <p className='mt-3 leading-6 text-[14px]'>Build better products with flexible tools, helpful documentation, <br /> and a team that champions your growth.</p>
                    </div>

                    <div className="w-[60%] max-_770_:w-full flex items-start gap-[20px] justify-end">

                        <div className="w-[30%] max-_770_:w-[50%] text-white">
                            <h1 className='uppercase font-bold text-[17px]'>Sitemap</h1>
                            <ul className='mt-3'>
                                {[{ title: "Module Pricing", id: "module-price" }, { title: "Ai Pricing", id: "ai-price" }, { title: "Review", id: "review" }, { title: "Faq's", id: "faq's" }].map((item, index) => {
                                    return <li key={index} onClick={() => scrollToSection(item.id)} className='footer_link'>{item.title}</li>
                                })}
                                <li className='footer_link'><Link to="/api-docs">API Docs</Link></li>
                                <li className='footer_link'><Link to="/contact">Contact</Link></li>
                            </ul>
                        </div>

                        <div className="w-[20%] max-_770_:w-[50%] text-white">
                            {socialsList.length > 0 && (
                                <>
                                    <h1 className='uppercase font-bold text-[17px]'>Socials</h1>
                                    <ul className='mt-3 flex flex-col gap-2'>
                                        {socialsList.map((item, index) => {
                                            return <li key={index}>
                                                <a href={formatExternalLink(item.href)} target="_blank" rel="noopener noreferrer" className="footer_link flex items-center gap-[10px] text-gray-300 hover:text-white transition-colors duration-300">
                                                    {item.icon}
                                                    {item.title}
                                                </a>
                                            </li>
                                        })}
                                    </ul>
                                </>
                            )}
                        </div>

                    </div>

                </div>

                <div className="border-t text-gray-300 pt-[40px] flex max-_770_:flex-wrap items-center justify-between max-_770_:gap-6">
                    <h1 className='text-[14px]'>© {GetDate.getFullYear()} AstroSphere API. All rights reserved.</h1>
                    <div className="flex items-center gap-[30px] text-[14px] max-_770_:w-full max-_770_:text-center flex-wrap">
                        {(dynamicPages || []).map((page, index) => (
                            <Link key={page.id || index} to={`/page/${page.slug}`} className='hover:text-white transition-colors duration-300'>
                                {page.title}
                            </Link>
                        ))}
                    </div>
                </div>

            </div>
        </div>
    )
}

export default Footer